module.exports = __webpack_public_path__ + "img/reflexo.d5619abb.jpg";